import { render, staticRenderFns } from "./ServicesCard.vue?vue&type=template&id=e9d84348&scoped=true&"
import script from "./ServicesCard.vue?vue&type=script&lang=js&"
export * from "./ServicesCard.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCard.vue?vue&type=style&index=0&id=e9d84348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d84348",
  null
  
)

export default component.exports